import EpiComponent from '@episerver/spa-core/EpiComponent';
import React, {ReactNode, ReactNodeArray} from 'react';
import SalePackagesWrapper from './SalePackagesWrapper';
import SalePackagesBlockData from '../../../Models/Content/SalePackagesBlockData';

export default class SalePackagesBlock extends EpiComponent<SalePackagesBlockData> {
  constructor(props) {
    super(props);
  }

  public render(): ReactNode | ReactNodeArray | null {
    return <SalePackagesWrapper context={this.getContext()} iContent={this.props.data} />;
  }
}
